export default "__VITE_ASSET__Ck_1tx8X__"